import { Link } from "react-router-dom";
import { Heart, Star } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { formatPrice, img } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function ProductCard({ product, index = 0 }) {
  const { addToCart, toggleWishlist, inWishlist } = useStore();
  const saved = inWishlist(product.id);
  return (
    <div data-testid={`product-card-${product.slug}`} className="group relative flex flex-col animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}>
      <Link to={`/product/${product.slug}`} className="relative block aspect-[3/4] overflow-hidden bg-[#F5F1E8] dark:bg-[#141414]">
        <img src={img(product.images?.[0])} alt={product.name} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
        <div className="absolute left-3 top-3 flex flex-col gap-1.5">
          {product.is_new && <span className="bg-black text-white text-[10px] tracking-[0.15em] uppercase px-2.5 py-1">New</span>}
          {product.on_sale && <span className="bg-[#D4AF37] text-black text-[10px] tracking-[0.15em] uppercase px-2.5 py-1">Sale</span>}
        </div>
        <button data-testid={`wishlist-toggle-${product.slug}`}
          onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
          className="absolute right-3 top-3 grid h-9 w-9 place-items-center rounded-full bg-white/85 dark:bg-black/60 backdrop-blur transition hover:scale-110">
          <Heart className={`h-4 w-4 ${saved ? "fill-[#D4AF37] text-[#D4AF37]" : "text-black dark:text-white"}`} />
        </button>
        <div className="absolute inset-x-0 bottom-0 translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 p-3">
          <Button data-testid={`quick-add-${product.slug}`} onClick={(e) => { e.preventDefault(); addToCart(product); }}
            className="w-full rounded-none bg-[#D4AF37] text-black font-semibold hover:brightness-110">Add to Cart</Button>
        </div>
      </Link>
      <div className="pt-4">
        <p className="text-[11px] tracking-[0.18em] uppercase text-muted-foreground">{product.category}</p>
        <Link to={`/product/${product.slug}`}>
          <h3 className="font-display text-lg leading-snug mt-1 hover:text-[#D4AF37] transition-colors">{product.name}</h3>
        </Link>
        <div className="mt-1.5 flex items-center gap-2">
          <span className="font-medium">{formatPrice(product.price)}</span>
          {product.compare_at_price && <span className="text-sm text-muted-foreground line-through">{formatPrice(product.compare_at_price)}</span>}
          <span className="ml-auto flex items-center gap-1 text-xs text-muted-foreground">
            <Star className="h-3.5 w-3.5 fill-[#D4AF37] text-[#D4AF37]" />{product.rating}
          </span>
        </div>
      </div>
    </div>
  );
}
